import PropTypes from 'prop-types';
import React from 'react';
import { Alert } from 'reactstrap';

/**
 * Centred warning shown in place of the dashboard content when the entity has
 * no meters configured at all. Spacing is symmetric rather than viewport
 * relative so the message cannot fall below the fold on short screens.
 * @param {object} props
 * @param {React.ReactNode} props.message - message describing the empty state.
 * @returns {React.ReactComponentElement} - NoMetersAlert component
 */
function NoMetersAlert({ message }) {
  return (
    <div className="d-flex justify-content-center align-items-center py-5">
      <Alert color="warning" className="text-center mb-0" fade={false}>
        {message}
      </Alert>
    </div>
  );
}

NoMetersAlert.propTypes = {
  message: PropTypes.node.isRequired,
};

export default NoMetersAlert;
